import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import ArrowRightIcon from '@icons/ArrowRightIcon';
import { BodyLarge, BodyMedium, LinkSmall } from '@styled';
import colors from '@general/colors';

const CTA = ({ headerText, ctaText, ctaUrl, ctaUrlIsInternal = false, ctaAction, showLarge = false }) => {
    const history = useHistory();
    const linkAttrs = {};

    if (ctaUrl) {
        linkAttrs.href = ctaUrl;
    }

    if (ctaAction) {
        linkAttrs.onClick = ctaAction;
    }

    return (
        <div className="d-md-flex justify-content-between">
            {headerText && !showLarge && <BodyMedium className="mb-3 mb-md-0">{headerText}</BodyMedium>}
            {headerText && showLarge && <BodyLarge className="mb-3 mb-md-0">{headerText}</BodyLarge>}
            {!headerText && <div />}

            {ctaText && (
                <LinkSmall
                    className="align-items-center cursor-pointer d-flex text-primary"
                    onClick={e => {
                        e.preventDefault();

                        if (ctaUrlIsInternal) {
                            history.push(ctaUrl);
                            return;
                        }

                        window.location.href = ctaUrl;
                    }}
                    {...linkAttrs}
                >
                    <span className="mr-0.5rem">{ctaText}</span>
                    <ArrowRightIcon color={colors.primary} />
                </LinkSmall>
            )}
        </div>
    );
};

CTA.propTypes = {
    headerText: PropTypes.string,
    ctaText: PropTypes.string,
    ctaUrl: PropTypes.string,
    ctaUrlIsInternal: PropTypes.bool,
    ctaAction: PropTypes.func,
    showLarge: PropTypes.bool,
};

export default CTA;
